
import { DownOutlined } from '@ant-design/icons';
import { DatePicker, Input, Select } from 'antd'
import moment from "moment";
import React from 'react'

const UserBasicInfo = ({ email, setEmail, emailError, designation, setDesignation, dob, setDob, blood, setBlood, gender, setGender }) => {
    const designations = ["Director", "Principal", "Centre Head", "Administrator", "Teacher", "Manager", "Marketing", "Others"]
    const genderTypes = ["Male", "Female", "Others"]
    const bloodTypes = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-",]
    const chevron = require('../../Assets/userManagementV3/chevron.png').default

    const handleDesignationChange = (value) => {
        setDesignation(value)
    }
    const handleDateChange = (value) => {
        setDob(value)
    }
    const handleGenderChange = (value) => {
        setGender(value)
    }
    const handleBloodChange = (value) => {
        setBlood(value)
    }

    return (
        <div className='basic-edit-profile-container'>
            <div className='basic-info-edit-title'>Basic information</div>

            <div className='basic-info-edit-flex-wrap-container'>
                <div style={{ width: '30%', }}>
                    <label className='email-label'>Email Id</label>
                    <Input
                    bordered={null}
                        className='email-input-border'
                        inputId={"-998"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}

                    />
                    {emailError && (
                        <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>Enter a valid email address</div>
                    )}
                </div>
                <div style={{ width: '30%' }}>
                    <label className='dob-designation-label-style'>Designation</label>
                    <Select
                        className="no-border-select-v3"
                        style={{ width: '100%', border: 'none',}}
                        onChange={handleDesignationChange}
                        value={designation}
                        suffixIcon = {<img src={chevron} alt="icon" />}
                    >
                        {designations?.map(item => (
                            <Option key={item} value={item}>
                                {item}
                            </Option>
                        ))}
                        
                    </Select>

                </div>
                <div className ='user-dob-v3' style={{ width: '30%' }}>
                    <label className='dob-designation-label-style'>DOB</label>
                    <div style={{border: 'none', borderBottom: '1px solid #E6E6E6',}}>
                    <DatePicker
                        bordered={null}
                        className='dob-v3'
                        style={{ width: '100%', }}
                        value={dob ? moment(dob, 'YYYY-MM-DD') : null}
                        format="DD/MM/YYYY"
                        inputReadOnly={true}
                        onChange={handleDateChange} />
                    </div>
                    
                </div>

            </div>

            <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-between', width: '65%', marginTop: '2%' }}>
                <div style={{ width: '46%', }}>
                    <label style={{ color: '#636363', fontSize: 12, fontWeight:400}}>Gender</label>
                    <Select
                        className="no-border-select-v3"
                        style={{ width: '100%', border: 'none', marginTop: -5 }}
                        onChange={handleGenderChange}
                        value={gender}
                        suffixIcon = {<img src={chevron} alt="icon" />}
                    >
                        {genderTypes?.map(item => (
                            <Option key={item} value={item}>
                                {item}
                            </Option>
                        ))}
                    </Select>
                </div>
                <div style={{ width: '46%' }}>
                    <label style={{ color: '#636363',  fontSize: 12, fontWeight:400}}>Blood group</label>
                    <Select
                        className="no-border-select-v3"
                        style={{ width: '100%', border: 'none', marginTop: -5 }}
                        onChange={handleBloodChange}
                        value={blood}
                        suffixIcon = {<img src={chevron} alt="icon" />}
                    >
                        {bloodTypes?.map(item => (
                            <Option key={item} value={item}>
                                {item}
                            </Option>
                        ))}
                    </Select>
                </div>

            </div>

        </div>
    )
}

export default UserBasicInfo